import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Citation by year",
    },
  },
};
const MultiLineChart = ({ data }) => {
  let left_time_range;
  let right_time_range;
  console.log("check data multiline", data)
  if (data.length > 0) {
    left_time_range = Object.keys(data[0].citation_by_year)[0];
    right_time_range = Object.keys(data[0].citation_by_year)[
      Object.keys(data[0].citation_by_year).length - 1
    ];
    data.map((item, index) => {
      if (Object.keys(item.citation_by_year)[0] < left_time_range) {
        left_time_range = Object.keys(item.citation_by_year)[0];
      }
      if (
        Object.keys(item.citation_by_year)[
          Object.keys(item.citation_by_year).length - 1
        ] > right_time_range
      ) {
        right_time_range = Object.keys(item.citation_by_year)[
          Object.keys(item.citation_by_year).length - 1
        ];
      }
    });
  }
  function createArray(m, n) {
    return Array.from({ length: n - m + 1 }, (_, index) => m + index);
  }
  const labels = createArray(
    parseInt(left_time_range, 10),
    parseInt(right_time_range, 10)
  );
  const colors = [
    "rgb(255, 190, 11)",
    "rgb(255, 0, 110)",
    "rgb(58, 134, 255)",
    "rgb(6, 214, 160)",
  ];

  const data_set = {
    labels,
    datasets: data.map((item, index) => {
      return {
        label: !item.department_name? item.name:`${item.name} - ${item.department_name}`,
        data: labels.map((label_item) => {
          if (!item.citation_by_year[`${label_item}`]) {
            return 0;
          } else return item.citation_by_year[`${label_item}`];
        }),
        borderColor: colors[index],
        backgroundColor: colors[index],
      };
    }),
  };

  return (
    <div>
      <Line options={options} data={data_set} />
    </div>
  );
};

export default MultiLineChart;
